import PropTypes from 'prop-types';
import React, { Component } from 'react';
import HorseRacingAbcPersonEntry from 'modules/HorseRacing/components/HorseRacingAbcPersonEntry';
import { compareStrings } from 'utils/compare.js';
import { TODAYS_RIDES_STRING, TODAYS_ENTRIES_STRING } from 'modules/HorseRacing/consts';

export default class HorseRacingPersonAbcTable extends Component {
  static propTypes = {
      rides: PropTypes.array,
      tableType: PropTypes.string
  }

  groupBy(entries, getId) {
    let groupedEntries = [];

    entries.map(entry => {
      const entryId = getId(entry);

      if (!groupedEntries[entryId]) {
        groupedEntries[entryId] = [];
      }

      groupedEntries[entryId].push(entry);
    });

    return groupedEntries;
  }

  groupByJockey(entries) {
    const jockeys = this.groupBy(entries, (entry) => this.entryId(entry, "jockeys"));
    const nonReservedJockeys = jockeys.filter(([{ride: {jockey: {first_names}}}]) => first_names !== "Reserve");
    return nonReservedJockeys.sort((...items) => compareStrings(...items.map(([{ride: {jockey: {last_name}}}]) => last_name)));
  }

  groupByTrainer(entries) {
    const trainers = this.groupBy(entries, (entry) => this.entryId(entry, "trainers"));
    return trainers.sort((...items) => compareStrings(...items.map(([{ride: {trainer: {last_name}}}]) => last_name)));
  }

  entryId({
      ride: {
        jockey: {
          person_reference: {
            id: jockeyId = ''
          } = {}
        } = {},
        trainer: {
          business_reference: {
            id: trainerId = ''
          } = {}
        } = {}
      } = {}
    }, tableType) {
    return tableType == "jockeys" ? jockeyId : trainerId;
  }

  render() {
    const {
      rides: entries,
      tableType = "jockeys"
    } = this.props;

    const groupedEntries = tableType == "jockeys" ?
      this.groupByJockey(entries) :
      this.groupByTrainer(entries);

    return <div className={`horse-racing-abc-guide-content ${tableType}Table`}>
      <span className="abc-guide-person-row">
        <div className="abc-guide-person-name jockey header">Jockey Name</div>
        <div className="abc-guide-person-name trainer header">Trainer Name</div>
        <div className="abc-guide-my-stable header"/>
        <div className="abc-guide-todays-rides header">{tableType == "jockeys" ? TODAYS_RIDES_STRING : TODAYS_ENTRIES_STRING}</div>
      </span>
      {groupedEntries.map(entry => <HorseRacingAbcPersonEntry entry={entry} key={this.entryId(entry[0], tableType)} tableType={tableType}/>)}
    </div>;
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingPersonAbcTable.js